import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Header from './Header/header'
import './layout.css'
// UI
import Normalize from './../style/normalize'

const Body = styled.div`
  /* margin-top: 85px; */
`

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: 'Sample' },
            {
              name: 'keywords',
              content:
                'Calgary Physical Therapy, Calgary Acupuncture, Calgary Rehabilitation,NE calgary cityscape physiotherapy, NE calgary skyview physiotherapy, north east calgary redstone, NE physiotherapy, calgary north east savanna physiotherapy, calgary NE martindale physiotherapy, NE Calgary NE taradale physiotherapy, north east calgary saddleridge physiotherapy, calgary cityscape chiropractor, NE calgary skyview chiropractor, north east calgary NE redstone chiropractor, calgary savanna chiropractor, calgary martindale chiropractor, calgary taradale chiropractor, calgary saddleridge chiropractor, NE calgary cityscape massage, calgary NE skyview massage therapist, north east Calgary NE redstone massage clinic , NE calgary savanna massage , calgary NE martindale massage, calgary taradale massage, calgary saddleridge massage therapist, NE calgary cityscape acupuncture,  Calgary NE  skyview acupuncture , north east calgary redstone , NE acupuncture, calgary north east savanna acupuncture, calgary NE martindale acupuncture, NE calgary taradale acupuncture, north east calgary saddleridge acupuncture, ne calgary physiotherapy, ne calgary chiropractor, ne calgary acupuncture, ne calgary meditation, ne calgary massage, ne calgary yoga, north east calgary, yyc, calgary, sewa physiotherapy, calgary physiotherapy, calgary physiotherapist,physiotherapy calgary,massage calgary, calgary massage, massage therapy calgary,acupuncture calgary, calgary acupuncture, chiropractor calgary, calgary chiropractor, north east calgary chiropractor, north east massage therapy, meditation therapy calgary, calgary meditation therapy, meditation calgary, dietitian calgary, calgary dietitian, dietcian calgary, calgary dietcian, best acupuncture clinic Calgary, top acupuncture clinic Calgary, best acupuncture clinic ne Calgary, top acupuncture clinic ne Calgary, best acupuncture clinic north east Calgary, top acupuncture clinic north east Calgary, best chiropractor clinic Calgary, top chiropractor clinic Calgary, best chiropractor clinic ne Calgary, top chiropractor clinic ne Calgary, best chiropractor clinic north east Calgary, top chiropractor clinic north east Calgary, best acupuncture clinic Calgary, top acupuncture clinic Calgary, best acupuncture clinic ne Calgary, top acupuncture clinic ne Calgary, best acupuncture clinic north east Calgary, top acupuncture clinic north east Calgary, best acupuncture clinic Calgary, top acupuncture clinic Calgary, best acupuncture clinic ne Calgary, top acupuncture clinic ne Calgary, best acupuncture clinic north east Calgary, top acupuncture clinic north east Calgary, best dietitian clinic Calgary, top dietitian clinic Calgary, best dietitian clinic ne Calgary, top dietitian clinic ne Calgary, best dietitian clinic north east Calgary, top dietitian clinic north east Calgary,yoga calgary , calgary yoga, yoga clinic calgary,motor vehicle injury(MVA), work injury(WCB), sports injury, joint muscle and ligament strains and sprains, post fracture, post surgery, vertigo, spinal adjustment, sciatica, calgary physio, calgary physiotherapy, calgary downtown physio, calgary downtown physiotherapy, downtown calgary physiotherapy clinic',
            },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <Header siteTitle={data.site.siteMetadata.title} />
        <Normalize />
        <Body>
          <ToastContainer />
          {children}
        </Body>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
